import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";

@Model()
class SocialAnalyseReport extends ApplicationRecord {
  static jsonapiType = "social_analyse_reports";

  @Attr() after: number;

  @Attr() before: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() name: string;

  @Attr() organisationTeamId: number;

  @Attr() rangeLabel: string;

  @Attr() selectedSocialContent: string[];

  @Attr() selectedWidgets: any[];

  @Attr() socialStreamIds: number[];

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default SocialAnalyseReport;
